<template>
  <div class="app-container">
    <Header></Header>
    <div class="main-container"
         :class="{'fullHeight': $route.path === '/'}">
      <router-view />
      <Footer v-if="$route.path !== '/'"></Footer>
    </div>
  </div>
</template>

<script>
import Footer from '@/views/layout/Footer.vue'
import Header from '@/views/layout/Header.vue'
export default {
  components: {
    Header,
    Footer
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.main-container {
  position: relative;
  top: 80px;
  width: 100%;
  margin: 0;
  padding: 0;
}
.fullHeight {
  height: 100%;
}
</style>
